module.exports = __webpack_public_path__ + "img/imposta-logo-alertmsg.1e92db0d.png";